import { SettingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Dashboard } from "../../../../components/ExportImgFigma";
import ".././stylestabs.scss";
import { formatNumber, mixGetV2 } from '../../../../services/mixin';
import MegaTable from "../../../../components/MagaTableV2";
import { SHOW_KEYNAME } from '../../../../env';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice';

const MaintenanceHistory = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const user = useSelector(selectorInfoUser);
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_care_repair_histories?.list.map((col: any) => {
      if (col.field === 'present_mile_age' || col.field === 'total_amount' || col.field === 'repair_amount' || col.field === 'item_amount' || col.field === 'invoice_service_total_amount') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value) === 'Không xác định' ? 0 : formatNumber(params.value)
        })
      } else if (col.field === 'contact_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          cellRenderer: (params: any) => {
            return (
              <div className={params.data.contact_name_id !== 'Không xác định' && params.data.contact_name_id ? 'cus-link-detail' : ''}>
                <a className="color-bage d-none" href={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.contact_name_id}`}>{params.data.contact_name}</a>
                <span className="text">{params.data.contact_name || 'Không xác định'}</span>
              </div>
            )
          },
        });
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheMaintenanceHistory',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: 'branch_name', headerName: 'Đơn vị' },
      // { field: 'route_name', headerName: 'Xưởng dịch vụ' },
      // { field: 'invoice_service_effective_get_date', headerName: 'Ngày sửa chữa' },
      // { field: 'lhsc', headerName: 'Loại hình  sửa chữa' },
      // { field: 'contact_name', headerName: 'Người liên hệ' },
      // { field: 'contact_tel', headerName: 'SĐT người liên hệ' },
      // { field: 'receive_date', headerName: 'Ngày giao xe' },
      // {
      //   field: 'present_mile_age', headerName: 'Số Km hiện tại', valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
      // { field: 'doc_date_remind', headerName: 'Ngày nhắc BD' },
      // {
      //   field: 'total_amount', headerName: 'Tổng tiền', valueFormatter: (params: any) =>
      //     formatNumber(params.value),
      // },
      // {
      //   field: 'repair_amount', headerName: 'Doanh thu công lao động', valueFormatter: (params: any) =>
      //     formatNumber(params.value),
      // },
      // {
      //   field: 'item_amount', headerName: 'Doanh thu vật tư', valueFormatter: (params: any) =>
      //     formatNumber(params.value),
      // },
      // { field: 'invoice_service_description', headerName: 'Nội dung sửa chữa' },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  const [loading, setLoading] = useState(false);
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/vehicle_service_history?id_sync=${stData.cus_id}&id_vehicle=${id}&admin_id=${user.id}`);
    if (res.data) {
      stChange({
        list: res.data,
        summary: res.summary
      }, 'vehicle_service_history');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.xesohuu_show && stData.xesohuu_show.id) {
      getDetail(stData.xesohuu_show.id);
    }
  }, [stData.xesohuu_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css  flex flex-1 flex-column rounded border mw-50 ">
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054" {...(SHOW_KEYNAME === true && { 'col-id': 'xesohuu_show_vehicle_service_history.summary.total_service_count' })}>
                {stData.xesohuu_show_vehicle_service_history && stData.xesohuu_show_vehicle_service_history.summary ? stData.xesohuu_show_vehicle_service_history.summary.total_service_count : 0}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần BD
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054" {...(SHOW_KEYNAME === true && { 'col-id': 'xesohuu_show_vehicle_service_history.summary.total_amount' })}>
                {formatNumber(stData.xesohuu_show_vehicle_service_history && stData.xesohuu_show_vehicle_service_history.summary ? stData.xesohuu_show_vehicle_service_history.summary.total_amount : 0)}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Tổng tiền
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054" {...(SHOW_KEYNAME === true && { 'col-id': 'xesohuu_show_vehicle_service_history.summary.latest_service_date' })}>
                {stData.xesohuu_show_vehicle_service_history && stData.xesohuu_show_vehicle_service_history.summary ? stData.xesohuu_show_vehicle_service_history.summary.latest_service_date : 'Không xác định'}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày BD gần nhất
              </span>
            </div>
          </div>
        </div>
      </div>

      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesohuu_show_vehicle_service_history && stData.xesohuu_show_vehicle_service_history.list ? stData.xesohuu_show_vehicle_service_history.list : [], loading: loading }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default MaintenanceHistory;
